import React, { useMemo } from "react";
import { StyledNavList } from "../style";
import { navigationLinks } from "../../../constants/navigationLinks";
import NavListItem from "./NavListItem";
import { checkManager } from "../../../helpFunctions/auth";
import { checkFreemiumUser } from "../../../helpFunctions/scenario";
import * as ROUTES from "../../../constants/routes";

const NavList = ({ currentPath, handleClick, authUser, organization }) => {
  const links = useMemo(() => {
    const isAdmin = checkManager(authUser?.claims, organization?.id); // Not selectedOrg but org saved in profile
    const isFreemiumUser = checkFreemiumUser(organization?.id);

    if (isAdmin) {
      return navigationLinks.filter(link => !link.freemiumOnly);
    } else if (isFreemiumUser) {
      return navigationLinks.filter(link => link.showForFreemium || link.href === ROUTES.SCENARIO_WIZARD);
    } else {
      return navigationLinks.filter(link => !link.adminOnly && !link.freemiumOnly);
    }
  }, [authUser?.claims, organization]);

  return (
    <StyledNavList>
      {links.map(link => (
        <NavListItem
          title={link.title}
          selected={link.href ? currentPath === link.href : false}
          key={link.title}
          handleClick={() => handleClick(link.href)}
          image={link.image}
        />
      ))}
    </StyledNavList>
  );
};

export default NavList;
